import { X } from "lucide-react";
import { SECTION_IDS, FILE_NAMES, scrollToSection } from "./files";

export const EditorTabs = ({ lang, activeSection }) => {
  const files = FILE_NAMES[lang];

  return (
    <div
      data-testid="ide-editor-tabs"
      className="h-9 shrink-0 flex items-stretch overflow-x-auto bg-[var(--sidebar)] border-b border-[var(--border)] select-none [&::-webkit-scrollbar]:hidden"
    >
      {SECTION_IDS.map((id) => {
        const active = activeSection === id;
        return (
          <button
            key={id}
            data-testid={`tab-${id}`}
            onClick={() => scrollToSection(id)}
            className={`relative flex items-center gap-2 px-4 font-mono text-[12px] whitespace-nowrap border-r border-[var(--border)] transition-colors ${
              active
                ? "bg-[var(--bg)] text-[var(--text)]"
                : "text-[var(--muted)] hover:text-[var(--text)] hover:bg-[var(--line-hover)]"
            }`}
          >
            {active && <span className="absolute top-0 left-0 right-0 h-[2px] bg-[#FF5722]" />}
            {files[id]}
            <X size={12} className={active ? "text-[var(--muted)]" : "text-transparent"} />
          </button>
        );
      })}
    </div>
  );
};
